import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3f6bd25a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Registrar compra", -1))
const _hoisted_3 = { class: "card-global card-centered" }
const _hoisted_4 = {
  class: "form-global",
  onsubmit: "event.preventDefault()"
}
const _hoisted_5 = { class: "column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label" }, "Código de la factura", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label" }, "Subtotal", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label" }, "IVA", -1))
const _hoisted_9 = { class: "column" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label" }, "Fecha de Facturación", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label" }, "Total", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label" }, "Proveedor", -1))
const _hoisted_13 = { class: "input-container" }
const _hoisted_14 = { class: "popup-card" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Seleccionar proveedor", -1))

import { ref, Ref, computed, ComputedRef, onMounted } from 'vue';
    import { IShopping } from '@/interfaces/IShopping';
    import { useShoppingStore } from '@/stores/shopping';
    import { useRouter } from 'vue-router';
    import swal from 'sweetalert';
    import TableComponent from '@/components/PortalComponents/TableComponent.vue';
    import { useThirdPartiesStore } from '@/stores/thirdParties'; 
    import { IThirdParty } from '@/interfaces/IThirdParties'; 
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'CreateShoppingView',
  setup(__props) {

    const router = useRouter();
    const thirdPartiesStore = useThirdPartiesStore();
    const shoppingStore = useShoppingStore();

    const getClientName = (data: IThirdParty) => {
        console.log("Seleccionado: ", data)
        shoppingForm.value.client = data.Cl_codigo
        openClientModal()
    }

    onMounted(() => {
        thirdPartiesStore.fetchDataList();
    })

    const shoppingForm : Ref = ref({
        id: null,
        subtotal: null,
        iva: 0.19,
        date: null,
        client: null
    })

    const total: ComputedRef<number> = computed(() => {
        return parseFloat((shoppingForm.value.subtotal * (1 + shoppingForm.value.iva)).toFixed(2));
    })

    const submitFrom = async () => {
        const shopping : IShopping = {
            Com_codigo: shoppingForm.value.id,
            Com_fechaGeneracion: new Date(shoppingForm.value.date),
            Com_subtotal: shoppingForm.value.subtotal,
            Com_precioTotal: total.value,
            Com_IVA: shoppingForm.value.iva,
            Cl_codigo: shoppingForm.value.client
        }

        if (await shoppingStore.createData(shopping)) {
            swal("Listo", "Se ha creado la compra", "success")
            shoppingStore.fetchDataList();
            router.push({name: 'shopping'})
        } else {
            console.log("Error, no se pudo crear la compra")
            swal("Error", "No se pudo crear la compra", "error")
        }
    }

    const clientModal = ref(false)
    const openClientModal = () => {
        clientModal.value = !clientModal.value
    }

    const closeModal = (event : Event ) => {
        if (event.target !== event.currentTarget) return;
        clientModal.value = false;
    }


return (_ctx: any,_cache: any) => {
  const _component_IconifyIcon = _resolveComponent("IconifyIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              required: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shoppingForm.value.id) = $event)),
              class: "input",
              type: "number",
              placeholder: "Código"
            }, null, 512), [
              [_vModelText, shoppingForm.value.id]
            ]),
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              required: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shoppingForm.value.subtotal) = $event)),
              class: "input",
              type: "number",
              placeholder: "Subtotal",
              step: ".01"
            }, null, 512), [
              [_vModelText, shoppingForm.value.subtotal]
            ]),
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              required: "",
              disabled: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shoppingForm.value.iva) = $event)),
              class: "input",
              type: "number",
              placeholder: "0.19",
              step: ".01",
              readonly: ""
            }, null, 512), [
              [_vModelText, shoppingForm.value.iva]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              required: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shoppingForm.value.date) = $event)),
              class: "input",
              type: "date",
              placeholder: "Fecha de Facturación"
            }, null, 512), [
              [_vModelText, shoppingForm.value.date]
            ]),
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              required: "",
              disabled: "",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((total).value = $event)),
              class: "input",
              type: "number",
              placeholder: "Total",
              readonly: ""
            }, null, 512), [
              [_vModelText, total.value]
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shoppingForm.value.client) = $event)),
                class: "input",
                type: "number",
                placeholder: "Proveedor ID",
                readonly: ""
              }, null, 512), [
                [_vModelText, shoppingForm.value.client]
              ]),
              _createElementVNode("button", {
                onClick: _withModifiers(openClientModal, ["prevent"]),
                class: "button-global-light size20"
              }, [
                _createVNode(_component_IconifyIcon, {
                  icon: "gridicons:dropdown",
                  height: "30px",
                  width: "30px"
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", { class: "flex-centered-button" }, [
          _createElementVNode("button", {
            class: "button-global btn-center",
            onClick: submitFrom
          }, "Crear")
        ])
      ])
    ]),
    (clientModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal",
          onClick: closeModal
        }, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(TableComponent, {
              onReturnSelectedRow: getClientName,
              headers: _unref(thirdPartiesStore).headers,
              data: _unref(thirdPartiesStore).dataList,
              "no-actions": true
            }, null, 8, ["headers", "data"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})